import { Reveal } from "./Reveal";
import { MANIFESTO, STATS } from "../data";

export const Manifesto = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-16 lg:py-24 px-6 lg:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-12">
        <Reveal className="md:col-span-4">
          <p className="inline-block bg-primary text-primary-foreground px-4 py-2 text-xs sm:text-sm uppercase tracking-[0.25em] font-bold">The Studio</p>
          <h2 className="mt-6 font-display font-medium text-4xl lg:text-5xl leading-[0.95] tracking-tight">
            We turn brands that are all{" "}
            <span className="font-accent text-primary">at sixes and sevens</span> into ones that
            can&apos;t be ignored.
          </h2>
        </Reveal>

        <div className="md:col-span-7 md:col-start-6 flex flex-col">
          {MANIFESTO.map((m, i) => (
            <Reveal
              key={m.n}
              delay={i * 0.05}
              className={`grid grid-cols-1 sm:grid-cols-12 gap-4 sm:gap-8 py-12 lg:py-16 ${
                i !== 0 ? "border-t border-foreground/10" : ""
              }`}
            >
              <span className="sm:col-span-3 font-accent text-6xl lg:text-8xl leading-none text-primary/90">
                {m.n}
              </span>
              <div className="sm:col-span-9">
                <h3 className="font-display font-bold text-2xl lg:text-3xl tracking-tight">{m.title}</h3>
                <p className="mt-4 font-body text-base lg:text-lg text-foreground/60 leading-relaxed max-w-xl">
                  {m.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Stats */}
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6">
        {STATS.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.08}
            className="bg-primary text-primary-foreground py-10 lg:py-14 px-6 lg:px-8"
          >
            <div className="font-display font-extrabold text-5xl lg:text-6xl tracking-tighter text-primary-foreground">
              {s.value}
            </div>
            <div className="mt-3 text-xs uppercase tracking-[0.2em] text-primary-foreground/80">{s.label}</div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
